import { Component, Story, Accents, Knobs } from './DocTypes';

const knobs: Knobs = {
  accent: {
    default: 'dolphinblue',
    editor: 'dropdown',
    editorOptions: Accents,
  },
  activeStep: {
    default: 'step1',
    editor: 'dropdown',
    editorOptions: ['step1', 'step2', 'step3'],
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'Basic vertical wizard',
  coreComponent: {
    html: `<tag-wizard-vertical accent='dolphinblue'>
  <tag-wizard-vertical-steps>
    <tag-wizard-vertical-step name='step1'>
      Step 1
    </tag-wizard-vertical-step>
    <tag-wizard-vertical-step name='step2'>
      Step 2
    </tag-wizard-vertical-step>
    <tag-wizard-vertical-step name='step3'>
      Step 3
    </tag-wizard-vertical-step>
  </tag-wizard-vertical-steps>
  <div style='width: 100%'>
    <tag-wizard-vertical-content name="step1" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag-text type='h3'>Step 1</tag-text>
        <tag-wizard-vertical-step-indicator>1/3</tag-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:flex-end; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag-button accent='dolphinblue' data-action='next-step'>Continue to next step</tag-button>
      </div>
    </tag-wizard-vertical-content>
    <tag-wizard-vertical-content name="step2" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag-text type='h3'>Step 2</tag-text>
        <tag-wizard-vertical-step-indicator>2/3</tag-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:space-between; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag-button data-action='previous-step' button-style='{"backgroundColor":"transparent", "border": "1px solid #53b8b4", "color": "#53b8b4"}'>Back to previous step</tag-button>
        <tag-button accent='dolphinblue' data-action='next-step'>Continue to next step</tag-button>
      </div>
    </tag-wizard-vertical-content>
    <tag-wizard-vertical-content name="step3" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag-text type='h3'>Step 3</tag-text>
        <tag-wizard-vertical-step-indicator>3/3</tag-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:space-between; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag-button data-action='previous-step' button-style='{"backgroundColor":"transparent", "border": "1px solid #53b8b4", "color": "#53b8b4"}'>Back to previous step</tag-button>
        <tag-button accent='dolphinblue' data-action='finish-step' button-style='{"width": "100px"}'>Finish</tag-button>
      </div>
    </tag-wizard-vertical-content>
  </div>
</tag-wizard-vertical>
`,
  },
  reactWrapper: {
    jsx: `<TagWizardVertical accent='dolphinblue'>
    <TagWizardVerticalSteps>
      <TagWizardVerticalStep name='step1'>
        Step 1
      </TagWizardVerticalStep>
      <TagWizardVerticalStep name='step2'>
        Step 2
      </TagWizardVerticalStep>
      <TagWizardVerticalStep name='step3'>
        Step 3
      </TagWizardVerticalStep>
    </TagWizardVerticalSteps>
    <div style={{width: '100%'}}>
      <TagWizardVerticalContent name="step1" style={{padding: '20px', position: 'relative', height: '100%'}}>
          <div style={{display:'flex', justifyContent:'space-between'}}>
          <TagText type='h3' text='Step 1'></TagText>
          <TagWizardVerticalStepIndicator>1/3</TagWizardVerticalStepIndicator>
        </div>
        <div style={{display:'flex', justifyContent:'flex-end', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
          <TagButton text='Continue to next step' accent='dolphinblue' data-action='next-step'></TagButton>
        </div>
      </TagWizardVerticalContent>
      <TagWizardVerticalContent name="step2" style={{padding: '20px', position: 'relative', height: '100%'}}>
        <div style={{display:'flex', justifyContent:'space-between'}}>
          <TagText type='h3' text='Step 2'></TagText>
          <TagWizardVerticalStepIndicator>2/3</TagWizardVerticalStepIndicator>
        </div>
        <div style={{display:'flex', justifyContent:'space-between', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
          <TagButton text='Back to previous step' data-action='previous-step' buttonStyle={{"backgroundColor":"transparent", "border": "1px solid #53b8b4", "color": "#53b8b4"}}></TagButton>
          <TagButton text='Continue to next step' accent='dolphinblue' data-action='next-step'></TagButton>
        </div>
      </TagWizardVerticalContent>
      <TagWizardVerticalContent name="step3" style={{padding: '20px', position: 'relative', height: '100%'}}>
          <div style={{display:'flex', justifyContent:'space-between'}}>
          <TagText type='h3' text='Step 3'></TagText>
          <TagWizardVerticalStepIndicator>3/3</TagWizardVerticalStepIndicator>
        </div>
        <div style={{display:'flex', justifyContent:'space-between', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
          <TagButton text='Back to previous step' data-action='previous-step' buttonStyle={{"backgroundColor":"transparent", "border": "1px solid #53b8b4", "color": "#53b8b4"}}></TagButton>
          <TagButton text='Finish' accent='dolphinblue' data-action='finish-step' buttonStyle={{"width": "100px"}}></TagButton>
        </div>
      </TagWizardVerticalContent>
    </div>
  </TagWizardVertical>
`,
  },
  coreComponent_v3: {
    html: `<tag3-wizard-vertical{{...knobs}}>
  <tag3-wizard-vertical-steps>
    <tag3-wizard-vertical-step name='step1'>
      Step 1
    </tag3-wizard-vertical-step>
    <tag3-wizard-vertical-step name='step2'>
      Step 2
    </tag3-wizard-vertical-step>
    <tag3-wizard-vertical-step name='step3'>
      Step 3
    </tag3-wizard-vertical-step>
  </tag3-wizard-vertical-steps>
  <div style='width: 100%'>
    <tag3-wizard-vertical-content name="step1" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag3-h3>Step 1</tag3-h3>
        <tag3-wizard-vertical-step-indicator>1/3</tag3-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:flex-end; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag3-simple-button {{accent}} data-action='next-step'>Continue to next step</tag3-simple-button>
      </div>
    </tag3-wizard-vertical-content>
    <tag3-wizard-vertical-content name="step2" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag3-h3>Step 2</tag3-h3>
        <tag3-wizard-vertical-step-indicator>2/3</tag3-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:space-between; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag3-tertiary-button {{accent}} data-action='previous-step'>Back to previous step</tag3-tertiary-button>
        <tag3-simple-button {{accent}} data-action='next-step'>Continue to next step</tag3-simple-button>
      </div>
    </tag3-wizard-vertical-content>
    <tag3-wizard-vertical-content name="step3" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag3-h3>Step 3</tag3-h3>
        <tag3-wizard-vertical-step-indicator>3/3</tag3-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:space-between; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag3-tertiary-button {{accent}} data-action='previous-step'>Back to previous step</tag3-tertiary-button>
        <tag3-simple-button {{accent}} data-action='finish-step' button-style='{"width": "100px"}'>Finish</tag3-simple-button>
      </div>
    </tag3-wizard-vertical-content>
  </div>
</tag3-wizard-vertical>
`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3WizardVertical{{...knobs}}>
  <Tag3WizardVerticalSteps>
    <Tag3WizardVerticalStep name='step1'>
      Step 1
    </Tag3WizardVerticalStep>
    <Tag3WizardVerticalStep name='step2'>
      Step 2
    </Tag3WizardVerticalStep>
    <Tag3WizardVerticalStep name='step3'>
      Step 3
    </Tag3WizardVerticalStep>
  </Tag3WizardVerticalSteps>
  <div style={{width: '100%'}}>
    <Tag3WizardVerticalContent name="step1" style={{padding: '20px', position: 'relative', height: '100%'}}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Tag3H3>Step 1</Tag3H3>
        <Tag3WizardVerticalStepIndicator>1/3</Tag3WizardVerticalStepIndicator>
      </div>
      <div style={{display:'flex', justifyContent:'flex-end', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
        <Tag3SimpleButton {{accent}} data-action='next-step'>Continue to next step</Tag3SimpleButton>
      </div>
    </Tag3WizardVerticalContent>
    <Tag3WizardVerticalContent name="step2" style={{padding: '20px', position: 'relative', height: '100%'}}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Tag3H3>Step 2</Tag3H3>
        <Tag3WizardVerticalStepIndicator>2/3</Tag3WizardVerticalStepIndicator>
      </div>
      <div style={{display:'flex', justifyContent:'space-between', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
        <Tag3TertiaryButton {{accent}} data-action='previous-step'>Back to previous step</Tag3TertiaryButton>
        <Tag3SimpleButton {{accent}} data-action='next-step'>Continue to next step</Tag3SimpleButton>
      </div>
    </Tag3WizardVerticalContent>
    <Tag3WizardVerticalContent name="step3" style={{padding: '20px', position: 'relative', height: '100%'}}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Tag3H3>Step 3</Tag3H3>
        <Tag3WizardVerticalStepIndicator>3/3</Tag3WizardVerticalStepIndicator>
      </div>
      <div style={{display:'flex', justifyContent:'space-between', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
        <Tag3TertiaryButton {{accent}} data-action='previous-step'>Back to previous step</Tag3TertiaryButton>
        <Tag3SimpleButton {{accent}} data-action='finish-step' buttonStyle={{width: "100px"}}>Finish</Tag3SimpleButton>
      </div>
    </Tag3WizardVerticalContent>
  </div>
</Tag3WizardVertical>`,

    knobs: knobs,
  },
};

const ValidationStory: Story = {
  title: 'Validation',
  description: 'Vertical wizard with step validation',
  coreComponent_v3: {
    html: `<tag3-wizard-vertical active-step='step1' accent='atoll'>
  <tag3-wizard-vertical-steps>
    <tag3-wizard-vertical-step name='step1'>
      Step 1
    </tag3-wizard-vertical-step>
    <tag3-wizard-vertical-step name='step2'>
      Step 2
    </tag3-wizard-vertical-step>
  </tag3-wizard-vertical-steps>
  <div style='width: 100%; height: 250px;'>
    <tag3-wizard-vertical-content name="step1" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag3-h3>Step 1</tag3-h3>
        <tag3-wizard-vertical-step-indicator>1/2</tag3-wizard-vertical-step-indicator>
      </div>
      <div>
        <tag3-validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='change' rule='required' error-element='.some-input-error'></tag3-validator>
        <tag3-input placeholder='Enter something ...' class='some-input'></tag3-input>
        <tag3-validation-alert class='some-input-error' style='display:none;'>You must enter something</tag3-validation-alert>
      </div>
      <div style='display:flex; justify-content:flex-end; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag3-simple-button accent='atoll' data-action='next-step' class='next-button'>Continue to next step</tag3-simple-button>
      </div>
    </tag3-wizard-vertical-content>
    <tag3-wizard-vertical-content name="step2" style='padding: 20px; position: relative; height: 100%;'>
      <div style='display:flex; justify-content:space-between;'>
        <tag3-h3>Step 2</tag3-h3>
        <tag3-wizard-vertical-step-indicator>2/2</tag3-wizard-vertical-step-indicator>
      </div>
      <div style='display:flex; justify-content:space-between; position: absolute; bottom: 60px; width:calc(100% - 50px);'>
        <tag3-tertiary-button accent='atoll' data-action='previous-step'>Back to previous step</tag3-tertiary-button>
        <tag3-simple-button accent='atoll' data-action='finish-step'>Finish</tag3-simple-button>
      </div>
    </tag3-wizard-vertical-content>
  </div>
</tag3-wizard-vertical>
`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3WizardVertical activeStep='step1' accent='atoll'>
  <Tag3WizardVerticalSteps>
    <Tag3WizardVerticalStep name='step1'>
      Step 1
    </Tag3WizardVerticalStep>
    <Tag3WizardVerticalStep name='step2'>
      Step 2
    </Tag3WizardVerticalStep>
  </Tag3WizardVerticalSteps>
  <div style={{width: '100%', height: '250px'}}>
    <Tag3WizardVerticalContent name="step1" style={{padding: '20px', position: 'relative', height: '100%'}}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Tag3H3>Step 1</Tag3H3>
        <Tag3WizardVerticalStepIndicator>1/2</Tag3WizardVerticalStepIndicator>
      </div>
      <div>
        <Tag3Validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='change' rule='required' error-element='.some-input-error'></Tag3Validator>
        <Tag3Input placeholder='Enter something ...' class='some-input'></Tag3Input>
        <Tag3ValidationAlert class='some-input-error' style={{display:'none'}}>You must enter something</Tag3ValidationAlert>
      </div>
      <div style={{display:'flex', justifyContent:'flex-end', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
        <Tag3SimpleButton accent='atoll' data-action='next-step' class='next-button'>Continue to next step</Tag3SimpleButton>
      </div>
    </Tag3WizardVerticalContent>
    <Tag3WizardVerticalContent name="step2" style={{padding: '20px', position: 'relative', height: '100%'}}>
      <div style={{display:'flex', justifyContent:'space-between'}}>
        <Tag3H3>Step 2</Tag3H3>
        <Tag3WizardVerticalStepIndicator>2/2</Tag3WizardVerticalStepIndicator>
      </div>
      <div style={{display:'flex', justifyContent:'space-between', position: 'absolute', bottom: '60px', width:'calc(100% - 50px)'}}>
        <Tag3TertiaryButton accent='atoll' data-action='previous-step'>Back to previous step</Tag3TertiaryButton>
        <Tag3SimpleButton accent='atoll' data-action='finish-step'>Finish</Tag3SimpleButton>
      </div>
    </Tag3WizardVerticalContent>
  </div>
</Tag3WizardVertical>
  `,
  },
};

// TODO - react demo
// TODO - controlled activeStep prop demo

const TagWizardVerticalStepsDocs: Component = {
  type: 'component',
  name: 'wizard-vertical-steps',
  description: 'A container for the steps in a vertical wizard',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

const TagWizardVerticalStepDocs: Component = {
  type: 'component',
  name: 'wizard-vertical-step',
  description: 'A container for the a step in a vertical wizard',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the step',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

const TagWizardVerticalContentDocs: Component = {
  type: 'component',
  name: 'wizard-vertical-content',
  description: 'A container for step content in a vertical wizard',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the step the content is for',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

const TagWizardVerticalStepIndicatorDocs: Component = {
  type: 'component',
  name: 'wizard-vertical-step-indicator',
  description: 'An indicator for the a step in a vertical wizard',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagWizardVerticalDocs: Component = {
  type: 'component',
  name: 'wizard-vertical',
  description: 'Renders a series screens with vertical steps',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'accent',
      description: 'The accent colour for the wizard',
      type: 'string',
    },
    {
      name: 'activeStep',
      description: 'The current active step name. This will switch the step, once set',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'activeStepChange',
      description: 'Raised when the active step changes',
      parameters: [
        {
          name: 'name',
          description: 'The new step name',
          type: 'string',
        },
      ],
    },
  ],
  methods: [],
  stories: [BasicStory, ValidationStory],
  childComponents: [
    TagWizardVerticalStepIndicatorDocs,
    TagWizardVerticalContentDocs,
    TagWizardVerticalStepDocs,
    TagWizardVerticalStepsDocs,
  ],
};
